<template>
  <div>
    <BackButton class="u-margin-bottom-small"></BackButton>
    <CreateQuestionForm @submit="updateQuestion($event)" :loadingSave="loadingSave" />
  </div>
</template>

<script>
import CreateQuestionForm from '@/pages/Questions/CreateQuestionForm';
import BackButton from '@/components/buttons/BackButton';
import DashboardElementController from '@/controllers/DashboardElement/DashboardElementController';
import QuestionController from '@/controllers/Question/QuestionController';
import ApproveQuestionController from '@/controllers/Question/ApproveQuestionController';
import QuestionConsumptionCategoryController from '@/controllers/Question/QuestionConsumptionCategoryController';
import SendQuestionNotificationController from '@/controllers/Question/SendQuestionNotificationController';
export default {
  name: 'EditQuestion',
  components: { BackButton, CreateQuestionForm },
  data() {
    return {
      loadingSave: false,
    };
  },
  methods: {
    async updateQuestion(event) {
      this.loadingSave = true;

      try {
        if (event.dashForm && event.dashForm.headline) {
          let dashElement = await DashboardElementController.update(event.dashForm, event.dashForm.id);
          event.form.dashboard_element_id = dashElement.id;
        }
        await QuestionController.update(event.form, event.form.id);

        if (event.form.consumption_category_ids && event.form.consumption_category_ids.length > 0) {
          await QuestionConsumptionCategoryController.store({
            question_id: event.form.id,
            consumption_category_ids: event.form.consumption_category_ids,
          });
        } else {
          await QuestionConsumptionCategoryController.destroy(event.form.id);
        }
        if (event.form.approved) await ApproveQuestionController.update(event.form.id);
        if (event.notify_users === true) await SendQuestionNotificationController.store(event.form.id);
        await this.$router.back();
        this.$notify({
          type: 'success',
          title: 'Successfully updated!',
        });
      } catch (error) {
        console.error(error);
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }

      this.loadingSave = false;
    },
  },
};
</script>

<style scoped></style>
